import { render, staticRenderFns } from "./DownloadsList.vue?vue&type=template&id=ab3866d2&"
import script from "./DownloadsList.vue?vue&type=script&lang=js&"
export * from "./DownloadsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports